import {
  RICHLIST_REQUEST,
  RICHLIST_LIST_SUCCESS,
  RICHLIST_LIST_FAIL,
  SET_ACTIVE_LIST,
} from '../constants/RichListConstants';

export const richListReducer = (
  state = { lists: [], stats: [], sectors: [], activeList: 'AFR2020' },
  action
) => {
  switch (action.type) {
    case RICHLIST_REQUEST:
      return { ...state, loading: true, stats: [] };
    case RICHLIST_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        lists: action.payload.lists,
        stats: action.payload.stats,
        sectors: action.payload.sectors,
      };
    case RICHLIST_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };
    case SET_ACTIVE_LIST:
      return { ...state, activeList: action.payload };
    default:
      return state;
  }
};
